import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'msc-showroom-exhibit-modal-page',
    templateUrl: './showroom-exhibit-modal-page.component.html',
    styleUrls: ['./showroom-exhibit-modal-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})

export class ShowroomExhibitModalPageComponent {

}
